import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Toasted from 'vue-toasted'
import ElementUI from 'element-ui'
import echarts from 'echarts'
import RefreshBlock from '@/components/RefreshBlock'
import SingleRing from '@/components/SingleRing'
import SingleHistogram from '@/components/SingleHistogram'
import SinglePieHistogramWrap from '@/components/SinglePieHistogramWrap'
import SingleSolidPie from '@/components/SingleSolidPie'
import DoubleGraph from '@/components/DoubleGraph'
import SingleGraph from '@/components/SingleGraph'
import SwitchStatus from '@/components/Switch'
import SwitchStatusValue from '@/components/SwitchValue'
import SwitchStatusTitle from '@/components/SwitchTitle'
import fullScreenDialog from '@/components/FullScreenDialog'
import RunningTime from '@/components/RunningTime'
import RunningTimeBig from '@/components/RunningTimeBig'
import HistoryChart from '@/components/HistoryChart'
import HistoryData from '@/components/HistoryData'
import HeaderTime from '@/components/HeaderTime'
import TimeBlock from '@/components/TimeBlock'
import RadarBlock from '@/components/RadarBlock'
import { BridgeBasePath } from './constants'

import 'normalize.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/common.scss'
import './assets/fonts/iconfont.css'

Vue.component('TimeBlock', TimeBlock)
Vue.component('HeaderTime', HeaderTime)
Vue.component('HistoryChart', HistoryChart)
Vue.component('RunningTime', RunningTime)
Vue.component('RunningTimeBig', RunningTimeBig)
Vue.component('SwitchStatus', SwitchStatus)
Vue.component('SwitchStatusValue', SwitchStatusValue)
Vue.component('SwitchStatusTitle', SwitchStatusTitle)
Vue.component('FullScreenDialog', fullScreenDialog)
Vue.component('SingleRing', SingleRing)
Vue.component('SingleGraph', SingleGraph)
Vue.component('DoubleGraph', DoubleGraph)
Vue.component('RefreshBlock', RefreshBlock)
Vue.component('SinglePieHistogramWrap', SinglePieHistogramWrap)
Vue.component('SingleHistogram', SingleHistogram)
Vue.component('SingleSolidPie', SingleSolidPie)
Vue.component('HistoryData', HistoryData)
Vue.component('RadarBlock', RadarBlock)

Vue.use(ElementUI, Toasted)

Vue.prototype.REFRESH_SECOND = 60000
Vue.prototype.REFRESH_SECOND_REMOTE_INPROGRESS = 15000

Vue.prototype.$http = axios
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 添加响应拦截器
axios.interceptors.response.use(
  function(response) {
    if (typeof response.data !== 'object') {
      Vue.prototype.$message({
        message: '无法识别的数据对象',
        type: 'error'
      })
      return Promise.reject(response)
    }
    return response
  },
  function(error) {
    const { response = {}, config = {} } = error
    const { data = {}, status = -1 } = response
    switch (status) {
      case -1:
        Vue.prototype.$message({
          message: '请求超时',
          type: 'error'
        })
        break
      case 300:
        Vue.prototype.$message({
          message: '警告哦，这是一条警告消息',
          type: 'error'
        })
        break
      case 400:
        const { info = '请求错误' } = data
        Vue.prototype.$message({
          message: info,
          type: 'error'
        })
        break
      case 401:
        const currentRoutePath = router.history.current.path
        if (currentRoutePath.indexOf('/login') === -1) {
          Vue.prototype.$message({ message: '登陆失效，请重新登陆', type: 'error' })
          let $url = '/login'
          BridgeBasePath.forEach(val => {
            if (currentRoutePath.indexOf(val) > -1) $url = `/${val}/login`
          })
          router.push($url)
        }
        break
      case 404:
        Vue.prototype.$message({
          message: `${config.url} 请求404`,
          type: 'error'
        })
        break
      case 500:
        Vue.prototype.$message({
          message: '内部服务错误',
          type: 'error'
        })
        break
      default:
        Vue.prototype.$message({
          message: '未知错误',
          type: 'error'
        })
    }
    return Promise.reject(error)
  }
)
